import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/** POST /api/transportista/notificaciones (body vacío) */
@Injectable({ providedIn: 'root' })
export class TransportistaNotificacionesGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/notificaciones', {}, options);
  }
}
